import React from 'react'
import { ContactNames } from './Data'

const Contact = () => {
    return (
        <>
        <div className="contact">
            <div className="contact__wrapper"></div>
            <div className="contact__content">
                <h1>Contact</h1>
                <div className="contact__content__inner">
                   {
                       ContactNames.map((item)=>{
                           return(
                            <div className="item1" key={item.id}>
                            <h2>{item.heading}</h2>
                            <h3>{item.person1}</h3>
                            <h3>{item.person2}</h3>
                            <h3>{item.person3}</h3>
                        </div>
                           )
                       })
                   }
                </div>
           </div>
        </div>
        </>
    )
}

export default Contact
